module.exports = __webpack_public_path__ + "static/media/item_33_4.65284943.png";